import { render, staticRenderFns } from "./cart-tag.vue?vue&type=template&id=5d61d79b"
import script from "./cart-tag.vue?vue&type=script&lang=js"
export * from "./cart-tag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports